import Dialog from '@mui/material/Dialog'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useDispatch, useSelector } from 'react-redux'

import ErrorMessageWithExclamation from '../../../../components/UI/ErrorMessageWithExclamation'
import { Button } from '../../../../components/UI'

import { DeleteAccountScheme } from '../../../../routing/utils/validators'

import { selectLoadingDeleteAccount } from '../../../../routing/fetchingfunction/user/user.reducer'
import { deleteAccount } from '../../../../routing/fetchingfunction/user/user.action'

const DeleteAccountConfirm = ({ open, onClose, onSuccessOpen }) => {
  const dispatch = useDispatch()

  const isLoading = useSelector(selectLoadingDeleteAccount)

  const {
    formState: { errors },
    reset,
    handleSubmit,
    register,
  } = useForm({
    defaultValues: {
      password: '',
    },
    resolver: yupResolver(DeleteAccountScheme),
  })

  const handleClose = () => {
    onClose()

    reset()
  }

  const handleFormSubmit = (data) => {
    dispatch(deleteAccount(data)).then((response) => {
      if (!response.error) {
        handleClose()

        setTimeout(() => {
          onSuccessOpen()
        }, 0)
      }
    })
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[532px] !p-[24px] !rounded-[12px] !bg-[#FDFDFD] !shadow-modal',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img
          src="/assets/icon/delete-account.svg"
          alt="Delete Acocunt"
          className="w-[124px] h-[124px]"
        />

        <h2 className="text-xl font-black text-primary-100 my-[16px]">Delete Account</h2>

        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div>
            <label htmlFor="password" className="mb-[6px] text-sm font-medium text-primary-100">
              Please type in your account password to confirm.
            </label>

            <input
              id="password"
              type="password"
              placeholder="Password"
              className="outline-none w-full rounded-[8px] bg-white shadow-button px-[14px] py-[10px] border-[#FFCA84] border-[1px] text-primary-100 text-base font-normal leading-[24px] placeholder:text-[#F6744380]"
              {...register('password')}
            />

            {errors.password && <ErrorMessageWithExclamation text={errors.password.message} />}
          </div>

          <div className="mt-[24px] w-full flex flex-col gap-y-[8px]">
            <Button type="submit" className="text-lg font-semibold !px-0" isLoading={isLoading}>
              I understand the consequences, delete this account
            </Button>

            <button
              type="button"
              className="w-full h-[44px] px-[16px] flex items-center justify-center rounded-[8px] shadow-button border-[1px] border-[#F79009] text-lg font-semibold text-[#F79009] !bg-transparent hover:!bg-primary-button-hover hover:border-primary-button-hover hover:text-white transition-colors duration-200 ease"
              onClick={handleClose}
            >
              No, cancel
            </button>
          </div>
        </form>
      </div>
    </Dialog>
  )
}

export default DeleteAccountConfirm
